import { Avatar, Grid, styled } from "@mui/material";
import HCheckArray from "../../../../../helpers/check-have-value";
import { memo } from "react";
import MxCImageCarousel from "./MxCImageCarousel";

interface MxCPropertyPictureProps {
  pictures: string[];
  onClick?: () => void;
}

const MxCPropertyPictureLarge = memo((props: MxCPropertyPictureProps) => {
  if (!HCheckArray(props.pictures)) {
    return (
      <ContentPicture>
        <CustomPicture alt="R" variant="square" onClick={props.onClick} />
      </ContentPicture>
    );
  }

  return (
    <ContentPicture>
      <MxCImageCarousel
        images={props.pictures}
        onClick={props.onClick}
        showIndicators={false}
        renderItem={(image, index) => (
          <CustomPicture
            key={image}
            alt={`Imagen ${index + 1}`}
            src={image}
            variant="square"
            onClick={props.onClick}
          />
        )}
      />
    </ContentPicture>
  );
});

export default MxCPropertyPictureLarge;

MxCPropertyPictureLarge.displayName = "MxCPropertyPicture";

const ContentPicture = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: 220,
  position: "relative",
  overflow: "hidden",

  [theme.breakpoints.up("sm")]: {
    height: 240
  },

  [theme.breakpoints.up("md")]: {
    height: 220
  },

  [theme.breakpoints.up("lg")]: {
    height: 220
  }
}));

const CustomPicture = styled(Avatar)(({ theme }) => ({
  width: "100%",
  height: 220,
  backgroundColor: theme.palette.grey[200],

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  }
}));
